

// import axios from 'axios';

// // ==================== ENVIRONMENT DETECTION ====================
// const isDevelopment = window.location.hostname === 'localhost' || 
//                       window.location.hostname === '127.0.0.1';

// let API_BASE: string;

// if (isDevelopment) {
//   API_BASE = 'http://localhost:8060/api';
// } else {
//   API_BASE = '/api';
// }

// console.log(`🌐 API Base URL: ${API_BASE} (${isDevelopment ? 'Development' : 'Production'})`);

// // ==================== API PATHS THAT DON'T REQUIRE AUTH ====================
// // Use exact path matching instead of includes
// const PUBLIC_PATHS = [
//   '/v1/auth/login',
//   '/v1/auth/signup',
//   '/v1/auth/send-otp',
//   '/v1/auth/verify-otp',
//   '/v1/auth/resend-otp',
//   '/v1/auth/check-otp-status',
//   '/v1/password/forgot',
//   '/v1/password/reset',
//   '/v1/password/validate-token',
//   '/health',
//   '/'
// ];

// const api = axios.create({
//   baseURL: API_BASE,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request interceptor
// api.interceptors.request.use(
//   (config) => {
//     // ============ FIX: Check exact path ============
//     const url = config.url || '';
//     const isPublic = PUBLIC_PATHS.some(path => url === path);
    
//     console.log(`🔑 Interceptor - URL: ${url}`);
//     console.log(`🔑 Interceptor - Is Public: ${isPublic}`);
    
//     if (isPublic) {
//       console.log('🔓 Public endpoint, no token required');
//       return config;
//     }
    
//     const token = localStorage.getItem('access_token');
//     console.log(`🔑 Interceptor - Token: ${token ? token.substring(0, 20) + '...' : 'null'}`);
    
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//       console.log('✅ Token added to request');
//     } else {
//       console.log('⚠️ No token available');
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response interceptor
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const url = error.config?.url || '';
//     const isPublic = PUBLIC_PATHS.some(path => url === path);
    
//     if (error.response?.status === 401 && !isPublic) {
//       console.log('🔐 Token expired, redirecting to login');
//       localStorage.clear();
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;

import axios from 'axios';

// ==================== ENVIRONMENT DETECTION ====================
const isDevelopment = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';

let API_BASE: string;

if (isDevelopment) {
  API_BASE = 'http://localhost:8060/api';
} else {
  API_BASE = '/api';
}

console.log(`🌐 API Base URL: ${API_BASE} (${isDevelopment ? 'Development' : 'Production'})`);

// ==================== API PATHS THAT DON'T REQUIRE AUTH ====================
// Use exact path matching instead of includes
const PUBLIC_PATHS = [
  '/v1/auth/login',
  '/v1/auth/signup',
  '/v1/auth/send-otp',
  '/v1/auth/verify-otp',
  '/v1/auth/resend-otp',
  '/v1/auth/check-otp-status',
  '/v1/password/forgot',
  '/v1/password/reset',
  '/v1/password/validate-token',
  '/health',
  '/'
];

// 👇 PATHS THAT SHOULD NOT TRIGGER LOGOUT ON 401
const NO_LOGOUT_PATHS = [
  '/v1/auth/change-password',
];

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // ============ FIX: Check exact path ============
    const url = config.url || '';
    const isPublic = PUBLIC_PATHS.some(path => url === path);
    
    console.log(`🔑 Interceptor - URL: ${url}`);
    console.log(`🔑 Interceptor - Is Public: ${isPublic}`);
    
    if (isPublic) {
      console.log('🔓 Public endpoint, no token required');
      return config;
    }
    
    const token = localStorage.getItem('access_token');
    console.log(`🔑 Interceptor - Token: ${token ? token.substring(0, 20) + '...' : 'null'}`);
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('✅ Token added to request');
    } else {
      console.log('⚠️ No token available');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const isPublic = PUBLIC_PATHS.some(path => url === path);
    const isNoLogoutPath = NO_LOGOUT_PATHS.some(path => url === path);
    
    // 👇 Check if it's a wrong password error
    // detail can be an object or a list (structured errors, 422 validation); only text is a message here.
    const rawDetail = error.response?.data?.detail;
    const errorMessage = typeof rawDetail === 'string' ? rawDetail : '';
    const isWrongPassword = errorMessage.includes('Current password is incorrect') ||
                           errorMessage === 'Current password is incorrect';

    // AI guard (backend/middleware/ai_guard.py): the server refused a scan/vendor/questionnaire
    // action because this tenant has no verified-working AI provider. Caught globally here, not
    // per-button, so every blocked action -- including one a future button forgets to check for
    // proactively -- still surfaces the same big popup. See components/AIGuardModal.tsx.
    if (error.response?.status === 412 && rawDetail && typeof rawDetail === 'object' && rawDetail.code === 'ai_not_configured') {
      window.dispatchEvent(new CustomEvent('fluxwatch:ai-blocked', {
        detail: { aiMode: rawDetail.ai_mode as 'byok' | 'platform', message: rawDetail.message as string },
      }));
      return Promise.reject(error);
    }

    // Signed in with a temporary password that hasn't been changed yet (tenant_middleware.py): go change it.
    if (error.response?.status === 403 && errorMessage === 'Change your temporary password to continue.') {
      if (window.location.pathname !== '/change-password') window.location.href = '/change-password';
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !isPublic) {
      // If it's change password with wrong password, DON'T logout
      if (isNoLogoutPath && isWrongPassword) {
        console.log('❌ Current password is incorrect - staying on page');
        return Promise.reject(error);
      }
      
      // If it's change password with any other 401, don't logout
      if (isNoLogoutPath) {
        console.log('🔐 Change password 401 - staying on page');
        return Promise.reject(error);
      }
      
      // Only logout for token expiration on other endpoints
      console.log('🔐 Token expired, redirecting to login');
      const idle = typeof rawDetail === 'string' && /inactivity/i.test(rawDetail);
      const revoked = typeof rawDetail === 'string' && /ended by an administrator/i.test(rawDetail);
      localStorage.clear();
      window.location.href = revoked ? '/login?reason=revoked' : idle ? '/login?reason=idle' : '/login';
    }
    return Promise.reject(error);
  }
);

export { API_BASE };
export default api;